import script from "./TheHeaderAcount.vue?vue&type=script&setup=true&lang=ts"
export * from "./TheHeaderAcount.vue?vue&type=script&setup=true&lang=ts"

import "./TheHeaderAcount.vue?vue&type=style&index=0&id=4a558222&lang=scss&scoped=true"

import exportComponent from "/home/matriXagent/git/center-secure/product/ap/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a558222"]])

export default __exports__